import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=42963eb2&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.vue?vue&type=style&index=0&id=42963eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42963eb2",
  null
  
)

export default component.exports